import { oc } from '@orpc/contract';
import { z } from 'zod';

/**
 * IndividualInclusion（例外割り当て）CRUD — BE inclusion.api-contract.ts のローカル mirror。
 * TODO(api-contract): publish 後に @standandforce/api-contract へ差し替え。
 */

const DeviceAssignmentInclusionItemSchema = z.object({
  id: z.string(),
  personId: z.string(),
  personName: z.string().nullable(),
  deviceId: z.string().nullable(),
  deviceName: z.string().nullable(),
  assignmentRuleId: z.string().nullable(),
  assignmentRuleName: z.string().nullable(),
  reason: z.string(),
  expiresAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date()
});
const ListDeviceAssignmentInclusionsInputSchema = z.object({
  includeExpired: z.boolean().optional(),
  personId: z.string().optional(),
  /** ルール詳細用（person+rule のみ。deviceId IS NULL を暗黙付与） */
  assignmentRuleId: z.string().optional(),
  /** システム例外セクション用（org 内の person+rule / person+device 全件） */
  scope: z.enum(['system']).optional()
}).superRefine((value, ctx) => {
  if (value.assignmentRuleId != null && value.scope != null) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'assignmentRuleId and scope cannot be specified together',
      path: ['scope']
    });
  }
});
const ListDeviceAssignmentInclusionsOutputSchema = z.object({
  inclusions: z.array(DeviceAssignmentInclusionItemSchema)
});
const DeviceAssignmentInclusionBodySchema = z.object({
  personId: z.string(),
  deviceId: z.string().nullable(),
  assignmentRuleId: z.string().nullable(),
  reason: z.string()
});
const IdOutputSchema = z.object({
  id: z.string()
});
export const deviceAssignmentInclusionContract = oc.router({
  list: oc.route({
    method: 'GET',
    path: '/v2/device-assignment/inclusions'
  }).input(ListDeviceAssignmentInclusionsInputSchema).output(ListDeviceAssignmentInclusionsOutputSchema),
  create: oc.route({
    method: 'POST',
    path: '/v2/device-assignment/inclusions'
  }).input(DeviceAssignmentInclusionBodySchema).output(IdOutputSchema),
  update: oc.route({
    method: 'PUT',
    path: '/v2/device-assignment/inclusions/{inclusionId}'
  }).input(DeviceAssignmentInclusionBodySchema.extend({
    inclusionId: z.string()
  })).output(IdOutputSchema),
  delete: oc.route({
    method: 'DELETE',
    path: '/v2/device-assignment/inclusions/{inclusionId}'
  }).input(z.object({
    inclusionId: z.string()
  })).output(IdOutputSchema)
});
export type DeviceAssignmentInclusionItem = z.infer<typeof DeviceAssignmentInclusionItemSchema>;
export type ListDeviceAssignmentInclusionsInput = z.infer<typeof ListDeviceAssignmentInclusionsInputSchema>;
export type DeviceAssignmentInclusionBody = z.infer<typeof DeviceAssignmentInclusionBodySchema>;